/* src/app/modules/ct-status/components/cts-gantry-functional-unit-grid/cts-gantry-functional-unit-grid.component.scss */
:host {
  display: flex;
  flex-flow: column nowrap;
  gap: 0.25rem;
}
.no-fn-unit {
  height: 1.75rem;
  min-width: 3.5rem;
  width: 100%;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  background-color: var(--base-0);
  border: 0.125rem solid rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
}
.no-fn-unit sh-text {
  width: max-content;
}
.cts-gantry-grid-highlight .no-fn-unit {
  border: 0.125rem solid rgba(0, 0, 0, 0.2);
}
/*# sourceMappingURL=cts-gantry-functional-unit-grid.component.css.map */
